module.exports = "/_next/static/images/Hero-xs@2x-e2137cac09b8b9b0ce815667affbed79.png";